/* reformly-005-sections.js
 *
 * Interactions for the 005 below-hero sections. Several sections emit this tag,
 * so the whole file is guarded — it runs once no matter how many times it loads.
 */
(function () {
  if (window.__r5sBooted) return;
  window.__r5sBooted = true;

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ---------------------------------------------------------------------
     Carousels — transformations + review strip.

     slidesPerView:'auto' at every breakpoint, with the card width owned by CSS
     (same pattern as the hero video rail). Numeric slidesPerView makes Swiper
     the sole authority on width, so if it fails to boot for any reason the
     slides fall back to Swiper's own `.swiper-slide{width:100%}` and a card
     stretches the full rail — which blows the 1:1 media up to ~1300px tall.
     Driving width from CSS keeps the layout correct with or without JS, and
     removes the pre-init flash of an oversized card.
     --------------------------------------------------------------------- */
  function initSwiperCarousel(root) {
    // Config lives on the outer [data-r5-carousel]; Swiper mounts on the inner rail.
    var scope = root.closest('[data-r5-carousel]') || root.parentElement;
    var conf = function (name, dflt) {
      var v = (scope && scope.getAttribute(name)) || root.getAttribute(name);
      return v === null || v === undefined ? dflt : v;
    };
    var autoMs = parseInt(conf('data-r5-auto', 0), 10) || 0;
    var gap = parseInt(conf('data-r5-gap', 0), 10) || 0;
    var prevEl = scope ? scope.querySelector('[data-r5-prev]') : null;
    var nextEl = scope ? scope.querySelector('[data-r5-next]') : null;

    // Only the full-bleed rail centres its card; bordered rails stay flush left.
    var bleed = root.hasAttribute('data-r5-bleed');

    var cfg = {
      slidesPerView: 'auto',
      spaceBetween: gap,
      centeredSlides: bleed,
      speed: 700,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        900: { centeredSlides: false }
      }
    };
    if (autoMs) {
      // disableOnInteraction:false — a swipe pauses autoplay, it does not kill it
      cfg.autoplay = { delay: autoMs, disableOnInteraction: false, pauseOnMouseEnter: true };
      cfg.loop = true;
    }
    if (prevEl && nextEl) cfg.navigation = { prevEl: prevEl, nextEl: nextEl };

    return new Swiper(root, cfg);
  }

  function bootCarousels() {
    $$('[data-r5-swiper]').forEach(initSwiperCarousel);
  }

  if (window.Swiper) {
    bootCarousels();
  } else {
    var waited = 0;
    var poll = setInterval(function () {
      if (window.Swiper) { clearInterval(poll); bootCarousels(); }
      else if ((waited += 50) > 5000) { clearInterval(poll); }
    }, 50);
  }

  /* ---------------------------------------------------------------------
     Why upgrade — tabs + video play/pause
     --------------------------------------------------------------------- */
  $$('[data-r5-why]').forEach(function (card) {
    $$('[data-r5-why-tab]', card).forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-r5-why-tab');
        $$('[data-r5-why-tab]', card).forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        $$('[data-r5-why-pane]', card).forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-r5-why-pane') === key);
        });
      });
    });

    var toggle = card.querySelector('[data-r5-why-toggle]');
    var video = card.querySelector('video');
    if (!toggle || !video) return;
    video.muted = true;
    toggle.addEventListener('click', function () {
      var label = toggle.querySelector('[data-r5-why-label]');
      if (video.paused) {
        var pr = video.play();
        if (pr && pr.catch) pr.catch(function () {});
        card.classList.remove('is-paused');
        if (label) label.textContent = 'Pause';
        toggle.setAttribute('aria-label', 'Pause');
      } else {
        video.pause();
        card.classList.add('is-paused');
        if (label) label.textContent = 'Play';
        toggle.setAttribute('aria-label', 'Play');
      }
    });
  });

  /* ---------------------------------------------------------------------
     How Reformly works — ported from reformly-plus-yearly-how-it-works.
     One <video> whose src swaps per step, plus the at4 Lottie on the last step.
     --------------------------------------------------------------------- */
  $$('[data-r5-how]').forEach(function (root) {
    var steps = $$('[data-r5-how-step]', root);
    var media = root.querySelector('.r5s-how__media');
    var video = root.querySelector('.r5s-how__video');
    var lottieWrap = root.querySelector('.r5s-how__lottie-wrap');
    var lottieBox = root.querySelector('.r5s-how__lottie');
    var lottieAnim = null;
    if (!steps.length || !video) return;

    // Reveal only once the new source has painted — kills the flash on swap
    ['loadeddata', 'playing'].forEach(function (ev) {
      video.addEventListener(ev, function () {
        video.style.transition = 'opacity 120ms ease';
        video.style.opacity = '1';
      });
    });

    function showMedia(step) {
      if (step.getAttribute('data-media-type') === 'lottie') {
        video.pause();
        video.style.display = 'none';
        if (lottieWrap) lottieWrap.style.display = 'block';
        if (!lottieAnim && window.lottie && lottieBox) {
          lottieAnim = window.lottie.loadAnimation({
            container: lottieBox,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: media.getAttribute('data-r5-how-lottie-src')
          });
        } else if (lottieAnim) {
          lottieAnim.goToAndPlay(0, true);
        }
        return;
      }
      if (lottieWrap) lottieWrap.style.display = 'none';
      video.style.display = 'block';
      var src = step.getAttribute('data-media-src');
      if (src && video.getAttribute('src') !== src) {
        video.style.transition = 'none';   // instant hide, no fade that exposes the frame beneath
        video.style.opacity = '0';
        video.setAttribute('src', src);
        video.load();
      }
      var pr = video.play();
      if (pr && pr.catch) pr.catch(function () {});
    }

    function activate(step) {
      steps.forEach(function (s) {
        var on = s === step;
        s.classList.toggle('is-open', on);
        s.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      showMedia(step);
    }

    steps.forEach(function (s) { s.addEventListener('click', function () { activate(s); }); });

    var first = root.querySelector('[data-r5-how-step].is-open') || steps[0];
    showMedia(first);
    // lottie lib is deferred; retry once it lands if the first step needs it
    if (first.getAttribute('data-media-type') === 'lottie' && !window.lottie) {
      window.addEventListener('load', function () {
        if (first.classList.contains('is-open')) showMedia(first);
      });
    }
  });

  /* ---------------------------------------------------------------------
     FAQ section accordion (one open at a time, like the capture)
     --------------------------------------------------------------------- */
  (function () {
    var faq2 = $$('[data-r5-faq2]');
    function closeItem(it) {
      if (!it.classList.contains('is-open')) return;
      var pn = it.querySelector('.r5s-faq__ans');
      if (pn) {
        pn.style.height = pn.scrollHeight + 'px';
        requestAnimationFrame(function () { pn.style.height = '0'; });
      }
      it.classList.remove('is-open');
      var b = it.querySelector('.r5s-faq__q');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    function openItem(it) {
      var pn = it.querySelector('.r5s-faq__ans');
      it.classList.add('is-open');
      if (pn) {
        // One measurement, write on the next frame — the old pair of forced
        // layouts ran on the tap itself, before the transition started.
        var target = pn.scrollHeight;
        pn.style.height = '0px';
        requestAnimationFrame(function () { pn.style.height = target + 'px'; });
      }
      var b = it.querySelector('.r5s-faq__q');
      if (b) b.setAttribute('aria-expanded', 'true');
    }
    faq2.forEach(function (it) {
      var pn = it.querySelector('.r5s-faq__ans');
      var btn = it.querySelector('.r5s-faq__q');
      if (!pn || !btn) return;
      pn.addEventListener('transitionend', function () {
        if (it.classList.contains('is-open')) pn.style.height = 'auto';
      });
      btn.addEventListener('click', function () {
        var willOpen = !it.classList.contains('is-open');
        faq2.forEach(closeItem);            // single-open
        if (willOpen) openItem(it);
      });
    });
  })();

  /* ---------------------------------------------------------------------
     Video testimonials — dots follow the swipe rail; tap swaps poster for video
     --------------------------------------------------------------------- */
  $$('[data-r5-vt-row]').forEach(function (row) {
    var dots = $$('[data-r5-vt-dot]', row.parentElement);
    if (dots.length) {
      row.addEventListener('scroll', function () {
        var i = Math.round(row.scrollLeft / (row.clientWidth * 0.85 + 14));
        i = Math.max(0, Math.min(dots.length - 1, i));
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }, { passive: true });
      dots.forEach(function (d, n) {
        d.addEventListener('click', function () {
          var card = row.children[n];
          if (card) row.scrollTo({ left: card.offsetLeft - row.offsetLeft, behavior: 'smooth' });
        });
      });
    }

    $$('[data-r5-vt-play]', row).forEach(function (media) {
      media.addEventListener('click', function () {
        if (media.classList.contains('is-playing')) return;
        var src = media.getAttribute('data-r5-vt-src');
        if (!src) return;
        media.classList.add('is-playing');
        var v = document.createElement('video');
        v.src = src;
        v.controls = true;
        v.playsInline = true;
        v.preload = 'none';
        media.appendChild(v);
        v.play();
      });
    });
  });

  /* ---------------------------------------------------------------------
     Section CTAs reuse whichever add-to-cart the page actually has
     ---------------------------------------------------------------------

     These sections were written against the am002/005 hero and forwarded the
     click to its ATC. They are now also used under reformly-plan-preview
     (page.onboarding-007/-008), which has no .r5__atc — so the lookup returned
     null and every one of these buttons silently did nothing.

     Ordered, not merged: a page with the hero keeps using it, so nothing about
     app-membership-002/005 changes. The fallback only matters where the hero is
     absent. */
  $$('[data-r5-scroll-atc]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.querySelector('.r5__atc[data-r5-atc]')
                || document.querySelector('[data-rpp-submit]');
      if (target) target.click();
    });
  });
})();
